import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { FeiKeyDef, WizConstants } from '@wizeoo/akm-compute-lib';
import { IWizItemRenderer, WizLabel, WizRoot, WizEventManager } from '@wizeoo/akm-component-lib';
import { AlkEvent } from '../../../../framework/events/alk.event';
import { ALK_EVENT_TYPE } from '../../../../model/enums';
import { Measure } from '@wizeoo/akm-message-lib';

/** Renderer vignette d'une entité métier */
@Component({
  selector: 'add-measure-renderer',
  templateUrl: './add-measure.renderer.html',
})
export class AddMeasureRenderer implements IWizItemRenderer<null, FeiKeyDef> {
  constructor(public elementRef: ElementRef) {}

  @ViewChild('lbTitle') lbTitle: WizLabel;
  @ViewChild('lbContent') lbContent: WizLabel;

  public showPen: boolean = false; // affichage du crayon d'édition, si éditable et mode I
  public showWeight: boolean = false; // affichage du poids si WeightGrid
  public showConstant: boolean = false; // affichage si constante

  public currentFormula: string = '';
  public currentMeasure: Measure;

  private _data: FeiKeyDef;
  public get data(): FeiKeyDef {
    return this._data;
  }
  @Input()
  public set data(data: FeiKeyDef) {
    this._data = data;
    this.currentMeasure = data.measure;

    this.currentFormula = this.currentMeasure['formula' + this.data.mode];

    this.showWeight = this.currentMeasure.mode === WizConstants.MEASURE_MODE_WEIGHT_GRID;
    this.showConstant = this.currentMeasure.mode === WizConstants.MEASURE_MODE_CONSTANT;
  }

  /** sélection / ou pas de la measure, depuis le graph */
  public selectMe(event: Event): void {
    WizEventManager.dispatchEvent(WizRoot.root(), new AlkEvent(ALK_EVENT_TYPE.MEASURE_QUICK_SELECT, this.data));
  }
}
